import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './PlanLoading.Config.Styles';

const percentageViewLoadingConfig = [
  {
    containerStyle: styles.planBodyFirstItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.planBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.planBodyItemSquare),
  },
  {
    containerStyle: styles.planBodyButtonContainer,
    main: setLoadingConfigObject('square', 1, null, styles.planBodyButton),
  },
  {
    containerStyle: styles.planBodyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.planBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.planBodyItemSquare),
  },
  {
    containerStyle: styles.planBodyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.planBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.planBodyItemSquare),
  },
  {
    containerStyle: styles.planBodyButtonContainer,
    main: setLoadingConfigObject('square', 1, null, styles.planBodyButton),
  },
];

const planBody = [
  {
    containerStyle: styles.planBodyItemContainer,
    main: setLoadingConfigObject('square', 1, null, styles.planBodyItemTitleSquare),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.planBodyItemSubTitleSquare),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.planBodyItemButtonSquare),
  },
];

const planBodyWithSeparator = theme => [
  ...planBody,
  {
    style: styles.separatorTwo(theme),
  },
];

const addViewLoadingConfig = theme => [
  ...planBodyWithSeparator(theme),
  ...planBodyWithSeparator(theme),
  ...planBody,
];

const setProgressLoadingConfig = (withPercentageView, theme) => [
  ...(withPercentageView ? percentageViewLoadingConfig : addViewLoadingConfig(theme)),
  {
    style: styles.separatorThree(theme),
  },
];

const usersLoadingConfig = theme => [
  {
    style: styles.separator(theme),
  },
  {
    containerStyle: styles.planBodyFirstItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.planUsersCircle),
    main: setLoadingConfigObject('square', 1, null, styles.planUsersSquare),
  },
];

const loadingConfig = (withPercentageView, withUsers, hideProgressBars, theme) => [
  {
    left: setLoadingConfigObject('line', 1, 80, styles.status),
  },
  {
    left: setLoadingConfigObject('square', 1, null, styles.title),
    main: setLoadingConfigObject('circle', 1, null, styles.circle),
  },
  ...(withUsers ? usersLoadingConfig(theme) : []),
  {
    style: styles.separatorTwo(theme),
  },
  ...(!hideProgressBars ? setProgressLoadingConfig(withPercentageView, theme) : []),
  {
    style: styles.itemContainer,
    left: setLoadingConfigObject('line', 1, 94, styles.itemLeft),
    right: setLoadingConfigObject('line', 1, 94, styles.itemRight),
  },
  {
    style: styles.separator(theme, 0),
  },

  {
    style: styles.marginStyle,
    left: setLoadingConfigObject('line', 1, 94, styles.itemLeft),
    right: setLoadingConfigObject('line', 1, 94, styles.itemLeft),
  },
  {
    style: styles.separator(theme, 0),
  },
  {
    style: styles.marginStyle,
    left: setLoadingConfigObject('line', 1, 94, styles.itemLeft),
    right: setLoadingConfigObject('line', 1, 94, styles.itemLeft),
  },
  {
    style: styles.separator(theme, 0),
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.button),
  },
];

export { loadingConfig, shimmerPlaceholderConfig };
